import React from "react";
import "./Home.css"; // Optional: for styling

function Home() {
  return (
    <div className="home-container">
      <h1>Welcome to JHR Supply Management Suite</h1>
      <p>
        Your all-in-one platform for managing inventory, transactions, and more.
      </p>
      {/* <div className="home-cta">
        <p>Please log in to continue.</p>
      </div> */}
    </div>
  );
}

export default Home;
